<template>
  <div>
    <!-- <a-button
      style="margin: 10px 0 10px 10px"
      v-acl="'page_device_export'"
      @click="exportDevices"
      >{{ $t("page_device_export") }}</a-button
    >-->
    <ExportButton
      :multi="true"
      :filename="exportFilename"
      :exportFn="handleExport"
      :disabled="!dataList.length"
      :selectedKeys="selectedRowKeys"
      style="margin: 16px 10px;"
    />
    <ml-table
      :columns="repairColumns"
      :dataSource="dataList"
      :pagination="false"
      :rowSelection="{
        selectedRowKeys,
        onChange: this.onSelectChange,
        onSelect: this.onSelect,
        onSelectAll: this.onSelectAll,
      }"
      :scroll="{ x: tableScrollWidth, y: tableScrollY }"
      :selectRowKey="repairId"
      :custom-row="rowClick"
      rowKey="id"
      style="background-color: #fff; margin: 0 10px"
    >
      <template slot="operation" slot-scope="text, record">
        <a @click="showModal($event, record)" v-acl="'page_device_detailed'">{{
          $t("page_device_detailed")
        }}</a>
      </template>
    </ml-table>
    <a-modal
      :title="$t('page_device_repair_record_details')"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleCancel"
      @cancel="handleCancel"
    >
      <a-form-model
        layout="inline"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 15 }"
      >
        <a-form-model-item :label="$t('page_device_repair_record_type') + ':'">
          <!-- <a-input v-model="form.recordTypeStr" /> -->
          <span>{{ form.recordTypeStr }}</span>
        </a-form-model-item>
        <div>
          <a-form-model-item
            :label="$t('page_plan_maintenance_task_number') + ':'"
          >
            <!-- <a-input v-model="form.recordCode" /> -->
            <span>{{ form.recordCode }}</span>
          </a-form-model-item>
          <a-form-model-item
            :label="$t('page_plan_maintenance_application_No') + ':'"
          >
            <!-- <a-input v-model="apply.applyCode" /> -->
            <span>{{ apply.applyCode }}</span>
          </a-form-model-item>
        </div>
        <div>
          <a-form-model-item
            :label="$t('page_plan_maintenance_equipment_coding') + ':'"
          >
            <!-- <a-input v-model="form.deviceCode" /> -->
            <span>{{ form.deviceCode }}</span>
          </a-form-model-item>
          <a-form-model-item :label="$t('page_card_workstation_name') + ':'">
            <!-- <a-input v-model="form.deviceName" /> -->
            <span>{{ form.deviceName }}</span>
          </a-form-model-item>
        </div>
        <div>
          <a-form-model-item :label="$t('page_business_device_type') + ':'">
            <!-- <a-input v-model="form.deviceTypeName" /> -->
            <span>{{ form.deviceTypeName }}</span>
          </a-form-model-item>
        </div>
        <div>
          <a-form-model-item
            :label="$t('page_device_repair_maintenance_applicant') + ':'"
          >
            <!-- <a-input v-model="apply.applyUserName" /> -->
            <span>{{ apply.applyUserName }}</span>
          </a-form-model-item>
          <a-form-model-item
            :label="$t('page_device_repair_application_time') + ':'"
          >
            <!-- <a-input v-model="apply.applyTime" /> -->
            <span>{{ apply.applyTime }}</span>
          </a-form-model-item>
        </div>
        <a-form-model-item
          :label="$t('page_device_repair_time_of_occurrence') + ':'"
        >
          <!-- <a-input v-model="form.malfunctionTime" /> -->
          <span>{{ form.malfunctionTime }}</span>
        </a-form-model-item>
        <div>
          <a-form-model-item :label="$t('page_device_repair_urgency') + ':'">
            <!-- <a-input v-model="form.urgencyStr" /> -->
            <span>{{ apply.urgencyStr }}</span>
          </a-form-model-item>
          <a-form-model-item
            :label="$t('page_device_repair_affect_production') + ':'"
          >
            <!-- <a-input v-model="form.isAffectStr" /> -->
            <span>{{ form.isAffectStr }}</span>
          </a-form-model-item>
        </div>
        <div style="width: 100%">
          <a-form-model-item
            :label="$t('page_device_repair_attachment_view') + ':'"
          >
            <div
              class="img-panel"
              v-for="(item, index) in pictureListInfo"
              :key="index"
            >
              <img
                v-if="item && item.type && item.type === 'image'"
                :src="item.content"
                @click="openPreview(index)"
                style="cursor: pointer;"
              />
              <div
                @click="openPreview(index)"
                style="position: absolute;z-index: 9999; width:192px; height: 178px;cursor: pointer"
              ></div>
              <embed
                v-if="item && item.type && item.type === 'application'"
                :src="item.content"
                type="application/pdf"
                style="cursor: pointer"
              />
              <div
                v-if="item && item.type && item.type === 'text'"
                @click="openPreview(index)"
              >
                <textarea
                  class="txt-content"
                  :placeholder="$t('common_please_input') + $t('page_device_repair_attachment_view')"
                  v-model="item.content"
                  style="cursor: pointer; color:#000000;"
                  disabled
                />
              </div>
            </div>
          </a-form-model-item>
        </div>
        <div>
          <a-form-model-item :label="$t('page_device_repair_person') + ':'">
            <!-- <a-input v-model="form.repairUserName" /> -->
            <span>{{ form.repairUserName }}</span>
          </a-form-model-item>
          <a-form-model-item
            :label="$t('page_device_repair_maintenance_time') + ':'"
          >
            <span>{{
              form.repairTime ? formatTimeSlot(form.repairTime) : ""
            }}</span>
          </a-form-model-item>
        </div>
        <div>
          <a-form-model-item :label="$t('page_plan_plan_start_time') + ':'">
            <!-- <a-input v-model="form.repairStartTime" /> -->
            <span>{{ form.repairStartTime }}</span>
          </a-form-model-item>
          <a-form-model-item :label="$t('page_device_end_time') + ':'">
            <!-- <a-input v-model="form.repairEndTime" /> -->
            <span>{{ form.repairEndTime }}</span>
          </a-form-model-item>
        </div>
        <div>
          <a-form-model-item
            :label="$t('page_device_repair_fault_details') + ':'"
          >
            <span>{{ form.malfunctionDetails }}</span>
          </a-form-model-item>
        </div>
        <a-form-model-item :label="$t('page_device_repair_fault_code') + ':'">
          <!-- <a-input v-model="form.malfunctionCode" /> -->
          <span>{{ form.errorCode }}</span>
        </a-form-model-item>
        <div>
          <ml-table :columns="columns" :dataSource="dataListChildren">
          </ml-table>
        </div>
        <a-form-model-item
          style="margin-top: 20px;"
          :label="$t('page_device_repair_maintenance_accessories') + ':'"
        >
          <div class="img-panel" v-for="(item, index) in listInfo" :key="index">
            <img
              v-if="item && item.type && item.type === 'image'"
              :src="item.content"
              @click="openRepairPreview(index)"
              style="cursor: pointer;"
            />
            <div
              @click="openRepairPreview(index)"
              style="position: absolute;z-index: 9999; width:192px; height: 178px;cursor: pointer"
            ></div>
            <embed
              v-if="item && item.type && item.type === 'application'"
              :src="item.content"
              type="application/pdf"
              style="cursor: pointer"
            />
            <div
              v-if="item && item.type && item.type === 'text'"
              @click="openRepairPreview(index)"
            >
              <textarea
                class="txt-content"
                :placeholder="$t('common_please_input') + $t('page_device_repair_maintenance_accessories')"
                v-model="item.content"
                style="cursor: pointer; color:#000000;"
                disabled
              />
            </div>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!--预览-->
    <previewImg
      :visible="previewSourceVisible"
      :imgs="pictureListInfo"
      :index="previewIndex"
      @cancel="closePreview"
      @changeEncode="changeEncode"
    />
    <previewImg
      :visible="repairVisible"
      :imgs="listInfo"
      :index="repairIndex"
      @cancel="closePreview"
      @changeRecordEncode="changeRecordEncode"
    />
  </div>
</template>

<script>
import { RepairRecordServiceProxy } from "@/service-proxies/app-v2/tpm.service-proxies";
import dayjs from "dayjs";
import { getImg, formatTimeSlot, getTxt } from "@/utils";
import { cloneDeep } from "lodash";
import { downloadFile } from "@/utils/index";
import { exportRecord } from "@/api/api.ts";
import ExportButton from "@/components/ExportButton/index.vue";
import previewImg from "@/components/PreviewImg/index.vue";
const repairRecordServiceProxy = new RepairRecordServiceProxy();
import { ServiceProxy as ResourceServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'
const resourceService = new ResourceServiceProxy()

export default {
  props: ["deviceId", "deviceTypeId"],
  components: { ExportButton, previewImg },
  data() {
    return {
      // repairColumns,
      visible: false,
      confirmLoading: false,
      previewVisible: false,
      previewImage: "",
      // columns,
      dataList: [],
      tableScrollWidth: 1700,
      tableScrollY: 300,
      repairId: "",
      selectedRowKeys: [],
      workStationId: "",
      form: [],
      apply: [],
      dataListChildren: [],
      fileList: [],
      picture: [],
      formatTimeSlot,
      exportTypeId: [],
      previewSourceVisible: false,
      previewIndex: 0,
      imgList: [],
      listInfo: [],
      pictureListInfo: [],
      encode: "UTF-8",
      repairPicture: [],
      listPicture: [],
      repairIndex: 0,
      repairVisible: false,
    };
  },
  created() {
    this.getRecordByDeviceId();
  },
  watch: {
    deviceId: {
      handler(val) {
        if (val) {
          this.getRecordByDeviceId();
        }
      },
    },
    visible: {
      handler(val) {
        if (val) {
          // this.getRecordByDeviceId();
          this.getApplyDetail();
        }
      },
    },
    repairTime: {
      handler(val) {
        this.form.repairTime = val;
      },
      immediate: true,
    },
  },
  computed: {
    exportFilename() {
      return this.$t("page_repair_record") + ".xlsx";
    },
    columns() {
      return [
        {
          title: this.$t("page_business_material_property_spare_parts"),
          dataIndex: "materialName",
        },
        { title: this.$t("page_device_repair_number"), dataIndex: "number" },
      ];
    },
    repairColumns() {
      return [
        {
          title: this.$t("actions"),
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          width: 100,
        },
        {
          title: this.$t("page_resource_pool_status"),
          dataIndex: "recordStatusStr",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_device_repair_order"),
          dataIndex: "recordCode",
          ellipsis: true,
          width: 200,
        },
        {
          title: this.$t("page_device_repair_urgency"),
          dataIndex: "urgencyStr",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_card_workstation_code"),
          dataIndex: "deviceCode",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_card_workstation_name"),
          dataIndex: "deviceName",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_device_repair_maintenance_applicant"),
          dataIndex: "applyUserName",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_device_repair_start_time"),
          dataIndex: "repairStartTime",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_device_repair_end_time"),
          dataIndex: "repairEndTime",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_device_Maintenance_time"),
          dataIndex: "repairTime",
          scopedSlots: { customRender: "repairTime" },
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_device_repair_person"),
          dataIndex: "repairUserName",
          ellipsis: true,
          width: 100,
        },
        {
          title: this.$t("page_device_Maintenance_describe"),
          dataIndex: "malfunctionDetails",
          ellipsis: true,
        },
      ];
    },
    repairTime() {
      // 维修用时
      if (this.form.repairEndTime && this.form.repairStartTime) {
        return dayjs(this.form.repairEndTime).diff(
          dayjs(this.form.repairStartTime),
          "minute"
        );
      } else {
        return null;
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      // console.log(selectedRowKeys)
    },
    onSelectAll(selected, selectedRows, changeRows) {
      this.exportTypeId = [];
      selectedRows.forEach((item) => {
        this.exportTypeId.push(item.id);
        // console.log("zzzzzzzzzzzz", this.exportTypeId);
      });
      // console.log(selected, selectedRows, changeRows);
    },
    onSelect(record, selected, selectedRows) {
      this.exportTypeId = [];
      selectedRows.forEach((item) => {
        this.exportTypeId.push(item.id);
        // console.log("zzzzzzzzzzzz", this.exportTypeId);
      });
      // console.log(record, selected, selectedRows);
    },
    showModal(e, record) {
      // e.stopPropagation();
      this.workStationId = record.id;
      this.visible = true;
    },
    handleCancel(e) {
      // console.log("Clicked cancel button");
      this.visible = false;
      // this.getRecordByDeviceId();
    },
    exportDevices() {
      if (this.exportTypeId.length) this.exportRecord();
    },
    async handleExport(type) {
      let params = {
        exportSelected: !!this.selectedRowKeys.length,
        selectedRecords: this.selectedRowKeys,
        recordStatus: "",
        deviceId: this.deviceId,
        deviceTypeId: this.deviceTypeId,
        keyWord: "",
      };
      if (type === "select") {
        Object.assign(params, { exportSelected: true });
      } else {
        Object.assign(params, { exportSelected: false });
      }
      return await exportRecord(params);
    },
    async getRecordByDeviceId() {
      let result = await repairRecordServiceProxy.getRecordByDeviceId(
        this.deviceId
      );
      this.dataList = result;
      this.selectedRowKeys = [];
      this.exportTypeId = [];
      if (this.dataList.length) {
        this.selectedRowKeys.push(this.dataList[0].id);
        this.exportTypeId.push(this.dataList[0].id);
        this.repairId = this.dataList[0].id;
      }
      if (this.dataList) {
        this.dataList.forEach((item) => {
          if (item.repairEndTime) {
            item.repairEndTime = dayjs(item.repairEndTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
          if (item.repairStartTime) {
            item.repairStartTime = dayjs(item.repairStartTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
          if (item.repairEndTime && item.repairStartTime) {
            let time = dayjs(item.repairEndTime).diff(
              dayjs(item.repairStartTime),
              "minute"
            );
            if (time) {
              item.repairTime = formatTimeSlot(time);
            } else {
              item.repairTime = "";
            }
          } else {
            return null;
          }
          // console.log("zasd",item.repairEndTime)
        });
      }
      // console.log("sdasd:", this.dataList);
    },
    async getApplyDetail() {
      this.picture = [];
      this.dataListChildren = [];
      let result = await repairRecordServiceProxy.getApplyDetail(
        this.workStationId
      );
      if (result) {
        this.form = result;
        this.form.repairEndTime = dayjs(this.form.repairEndTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.form.repairStartTime = dayjs(this.form.repairStartTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        // this.form.repairTime = dayjs(this.form.repairTime).format(
        //   "YYYY-MM-DD HH:mm:ss"
        // );
        this.form.malfunctionTime = dayjs(this.form.malfunctionTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      if (result.repairApplyDetailVo) {
        this.apply = result.repairApplyDetailVo;
        this.apply.applyTime = dayjs(this.apply.applyTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      if (result.materialVOList) {
        this.dataListChildren = result.materialVOList;
      }
      if (result.recordFileAddDTOList) {
        this.listPicture = result.recordFileAddDTOList;
        this.getPictureListInfo();
        // result.recordFileAddDTOList.map(async (file, index) => {
        //   this.picture[index] = await getImg(file);
        //   this.picture = cloneDeep(this.picture);
        //   // console.log("qqqqqqqqqq:", this.picture);
        // });
      }
      if (result.repairApplyDetailVo) {
        // result.repairApplyDetailVo.fileAddDTOList.map(async (file, index) => {
        //   this.fileList[index] = await getImg(file);
        //   this.fileList = cloneDeep(this.fileList);
        //   // console.log("qqqqqqqqqq:", this.picture);
        // });
        this.repairPicture = result.repairApplyDetailVo.fileAddDTOList;
        this.getListInfo();
      }
    },
    async exportRecord() {
      let params = {
        exportSelected: true,
        selectedRecords: this.exportTypeId,
      };
      let result = await exportRecord(params);
      downloadFile(result, "repair.xlsx");
    },
    rowClick(record) {
      return {
        on: {
          click: (event) => {
            // console.log("aaaaaa", record);
            this.repairId = record.id;
            this.selectedRowKeys = [];
            this.selectedRowKeys.push(record.id);
          },
        },
      };
    },
    openPreview(i) {
      this.previewSourceVisible = true;
      this.previewIndex = i;
      // this.imgList = arr;
      // console.log("imgList:", this.imgList);
    },
    openRepairPreview(i) {
      this.repairVisible = true;
      this.repairIndex = i;
      // this.imgList = arr;
      // console.log("imgList:", this.imgList);
    },
    closePreview() {
      this.previewSourceVisible = false;
      this.repairVisible = false;
    },
    changeEncode(val) {
      this.encode = val;
      this.getPictureListInfo();
    },
    changeRecordEncode(val) {
      this.encode = val;
      this.getListInfo();
    },
    getPictureListInfo() {
      this.pictureListInfo = [];
      this.listPicture.map(async (file, index) => {
        let content;

        if (
          file.contentType != "image/jpg" &&
          file.contentType != "image/jpeg" &&
          file.contentType != "image/png" &&
          file.contentType != "image/svg" &&
          file.contentType != "image/gif" &&
          file.contentType != "text/txt" &&
          file.contentType != "text/json" &&
          file.contentType != "application/pdf" &&
          file.contentType != "application/swf" &&
          file.contentType != "image/octet-stream"
        ) {
          file.contentType = "text/txt";
          content = await getTxt(file, this.encode);
        }

        if (file.contentType.indexOf("image") > -1) {
          content = await getImg(file);
        }

        if (file.contentType.indexOf("pdf") > -1) {
          content = await (
            await resourceService.statFileUsingGET(file.objectKey)
          ).data.link;
        }

        let temp = {
          type: file.contentType.substring(0, file.contentType.indexOf("/")),
          content,
        };
        this.pictureListInfo[index] = temp;
        this.pictureListInfo = cloneDeep(this.pictureListInfo);
      });
    },
    getListInfo() {
      this.listInfo = [];
      this.repairPicture.map(async (file, index) => {
          let content;

          if (
            file.contentType != "image/jpg" &&
            file.contentType != "image/jpeg" &&
            file.contentType != "image/png" &&
            file.contentType != "image/svg" &&
            file.contentType != "image/gif" &&
            file.contentType != "text/txt" &&
            file.contentType != "text/json" &&
            file.contentType != "application/pdf" &&
            file.contentType != "application/swf" &&
            file.contentType != "image/octet-stream"
          ) {
            file.contentType = "text/txt";
            content = await getTxt(file, this.encode);
          }

          if (file.contentType.indexOf("image") > -1) {
            content = await getImg(file);
          }

          if (file.contentType.indexOf("pdf") > -1) {
            content = await (
              await resourceService.statFileUsingGET(file.objectKey)
            ).data.link;
          }

          let temp = {
            type: file.contentType.substring(0, file.contentType.indexOf("/")),
            content,
          };
        this.listInfo[index] = temp;
        this.listInfo = cloneDeep(this.listInfo);
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-modal {
  width: 900px !important;
  top: 50px;
}
/deep/ .ant-form-inline .ant-form-item {
  width: 400px !important;
}
.ant-form-item {
  margin-bottom: 0 !important;
}
.upload-list-inline {
  width: 50px;
}
.img-panel {
  margin-bottom: 10px;
  background-color: #fafafa;
  color: #00000025;
  border: 1px solid #00000025;
  width: 192px;
  height: 178px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
img {
  width: 100%;
  height: 100%;
}
.txt-content {
  width: 100%;
  margin: 0 auto 16px;
  height: 100%;
  background-color: #f5f5f5;
  border-radius: 2px;
  border: solid 1px rgba(0, 0, 0, 0.15);
  padding: 8px;
  display: block;
  resize: none;
}
</style>
